/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Filter_No_VeknInputs */



/**
* | output |
* | --- |
* | "No VEKN" |
*
* @param {User_List_Filter_No_VeknInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_filter_no_vekn = /** @type {((inputs?: User_List_Filter_No_VeknInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Filter_No_VeknInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sans VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Senza VEKN")
	return /** @type {LocalizedString} */ ("No VEKN")
});